define(['exports', 'react', '../../i18n', './CloseButtonDialog', './Button', '../utils/uiHelper', 'material-ui'], function (exports, _react, _i18n, _CloseButtonDialog, _Button, _uiHelper, _materialUi) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _i18n2 = _interopRequireDefault(_i18n);

  var _CloseButtonDialog2 = _interopRequireDefault(_CloseButtonDialog);

  var _Button2 = _interopRequireDefault(_Button);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var DeleteConfirmationModal = function (_React$Component) {
    _inherits(DeleteConfirmationModal, _React$Component);

    function DeleteConfirmationModal(props) {
      _classCallCheck(this, DeleteConfirmationModal);

      var _this = _possibleConstructorReturn(this, (DeleteConfirmationModal.__proto__ || Object.getPrototypeOf(DeleteConfirmationModal)).call(this, props));

      _this.state = { open: false, id: null, name: '', type: '' };
      return _this;
    }

    _createClass(DeleteConfirmationModal, [{
      key: 'handleOpen',
      value: function handleOpen(id, name, type) {
        (0, _uiHelper.disablePageScroll)();
        this.setState({ open: true, id: id, name: name, type: type });
      }
    }, {
      key: 'handleClose',
      value: function handleClose() {
        if (!this.state.open) {
          return;
        }

        (0, _uiHelper.enablePageScroll)();
        this.setState({ open: false, id: null, name: '', type: '' });
      }
    }, {
      key: 'renderTitle',
      value: function renderTitle() {
        var _state = this.state,
            id = _state.id,
            name = _state.name,
            type = _state.type;

        return _react2.default.createElement(
          'div',
          { className: 'h3 flex' },
          _react2.default.createElement(
            'div',
            null,
            _i18n2.default.t('dk-ui-lib.delete_confirmation_desc')
          ),
          _react2.default.createElement(
            'div',
            { className: 'mx1 bold black' },
            name
          ),
          _react2.default.createElement(
            'div',
            null,
            type,
            '?'
          )
        );
      }
    }, {
      key: 'handleDeleteItem',
      value: function handleDeleteItem() {
        var id = this.state.id;

        if (!id) {
          return;
        }
        this.props.handleDelete(id);
        this.handleClose();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var actions = [_react2.default.createElement(_materialUi.FlatButton, {
          label: _i18n2.default.t('dk-ui-lib.buttons.cancel'),
          onClick: function onClick() {
            return _this2.handleClose();
          }
        }), _react2.default.createElement(_materialUi.FlatButton, {
          label: _i18n2.default.t('dk-ui-lib.buttons.delete'),
          primary: true,
          onClick: function onClick() {
            return _this2.handleDeleteItem();
          }
        })];
        return _react2.default.createElement(
          'div',
          { className: 'col-12' },
          _react2.default.createElement(_CloseButtonDialog2.default, {
            open: this.state.open,
            modal: false,
            actions: actions,
            title: this.renderTitle(),
            autoScrollBodyContent: true,
            contentStyle: { 'margin': ' auto', 'maxWidth': '100%', 'width': '50%' },
            onRequestClose: function onRequestClose() {
              return _this2.handleClose();
            } })
        );
      }
    }]);

    return DeleteConfirmationModal;
  }(_react2.default.Component);

  exports.default = DeleteConfirmationModal;


  DeleteConfirmationModal.propTypes = {};
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/DeleteConfirmationModal.js
// module id = 1172
// module chunks = 0